module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Logic Pool")])])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle"
  }, [_vm._v("A.D. 3698")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("This time he would reach the Sky. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This time")]), _vm._v(", before the Culling cut him away…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The tree of axiomatic systems beneath him was broad, deep, strong. He looked around him, at sibling-twins who had branched at choice-points, most of them thin, insipid structures. They spread into the distance, infiltrating the Pool with their webs of logic. He almost pitied their attenuated forms as he reached upwards, his own rich growth path assured…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Almost pitied. But when the Sky was so close there was no time for pity, no time for awareness of anything but growth, extension.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Little consciousness persisted between Cullings. But he could remember a little of his last birthing; and surely he had never risen so high, never felt the logical richness of the tree beneath him surge upwards through him like this, empowering him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Now there was something ahead of him: a new postulate, hanging above him like some immense fruit. He approached it warily, savoring its compact, elegant form.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The fibers of his being pulsed as the few, strong axioms at the core of his structure sought to envelop this new state"), _c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v("ment. But they could not. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They could not")]), _vm._v(". The new statement was undecidable, not deducible from the set within him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His excitement grew. The new hypothesis was simple of expression, yet rich in unfolding consequence. He would absorb its structure and bud, once more, into two siblings; and he knew that whichever true-false branch his awareness followed he would continue to enjoy richness, growth, logical diversity. He would drive on, building theorem on mighty theorem until at last—this time, he knew it would happen—this time, he would touch the Sky itself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("then")]), _vm._v(", he would—")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But there was a soundless pulse of light, far below him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He looked down, dread flooding him. It was as if a floor of light had spread across the Pool beneath him, shining with deadly blandness, neatly cauterizing his axiomatic roots.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culling")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In agony he looked up. He tried to nestle against the information-rich flank of the postulate fruit, but it hung—achingly—just out of reach.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And already his roots were crumbling, withdrawing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In his rage he lunged past the hypothesis-fruit and up at the Sky, stabbed at its bland completeness, poured all his energies against it!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("…And, for a precious instant, he reached "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("beyond the Sky")]), _vm._v(", and into something warm, yielding, weak. A small patch of the Sky was dulled, as if bruised.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He recoiled, exhausted, astonished at his own anger.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Sky curved over him like an immense, shining bowl as he shriveled back to the Culled base floor, he and millions of bud-siblings, their faces turned up to that forever unreachable light…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No")]), _vm._v(", he told himself as the emptiness of the Cull sank into his awareness. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not forever. Each time I, the inner I, persists through the Cull. Just a little, but each time a little more. I will emerge stronger, more ready, still hungrier than before.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page39"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And at last")]), _vm._v(", he thought, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("at last I will burst through the Sky. And then there will be no more Culls")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Shrieking, he dissolved into the base Cull floor.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The flitter was new, cramped and smelled of smooth, clean plastic, and it descended in silence save for the precise hiss of its jets. It crunched gently into the surface of Nereid, about a mile from Marsden’s dome.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen peered through the cabin windows at the shabby moonscape. Marsden’s dome was just over the compact horizon, intact, sleek, private. “Lethe,” Chen said. “I always hated assignments like these. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Loners")]), _vm._v(". You never know what you’re going to find.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan laughed, his voice obscured as he pulled his face plate down. “So easily shocked? And I thought you police were tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Ex-police,” Chen corrected automatically. She waved a gloved hand at the dome. “Look out there. What kind of person lives alone, for years, in a forsaken place like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s what we’ve been sent to find out.” Bayliss, the third person in the flitter, was adjusting her own headgear with neat, precise movements of her small hands. Chen found herself watching, fascinated; those little hands were like a bird’s claws, she thought with faint repulsion. “Marsden was a fine physicist,” Bayliss said, her augmented eyes glinting. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is")]), _vm._v(" a fine physicist, I mean. His early experimental work on quantum nonlinearity is still—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan laughed, ignoring Bayliss. “So we have already reached the limits of your empathy, Susan Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Let’s get on with this,” Chen growled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan cracked the flitter’s hatch.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One by one they dropped to the surface, Chen last, like huge, ungainly snowflakes. The Sun was a bright star close to this little moon’s horizon; knife-sharp shadows scoured the satellite’s surface. Chen scuffed at the surface with her "), _c('a', {
    attrs: {
      "id": "page40"
    }
  }), _vm._v("boot. The regolith was fine, powdery, ancient. Undisturbed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not for much longer")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Beyond Marsden’s dome, the huge bulk of Neptune floated, Earth-blue, like a bloated vision of the home planet. Cirrus clouds cast precise shadows on oceans of methane a thousand miles below. The new wormhole Interface slid across the face of Neptune, glowing, a tetrahedron of baby-blue and gold. Lights moved about it purposefully; Chen peered up longingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Look at this moonscape.” Hassan’s dark face was all but invisible behind his gold-tinted visor. “Doesn’t your heart expand in this ancient grandeur, Susan Chen? What person would not wish to spend time alone here, in contemplation of the infinite?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All loners are trouble")]), _vm._v(", Chen thought. No one came out to a place as remote as this was—or had been anyway, before the wormhole was dragged out here—unless he or she had a damn good reason.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen knew she was going to have to find out Marsden’s reason. She just prayed it was something harmless, academic, remote from the concerns of humanity; otherwise she really, really didn’t want to know.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan was grinning at her discomfiture, his teeth white through the gold of his face plate. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Let him")]), _vm._v(". She tilted her head back and tried to make out patterns in Neptune’s clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("There were a couple of subsidiary structures: lower domes, nestling against the parent as if for warmth; Chen could see bulk stores piled up inside the domes. There was a small flitter, outmoded but obviously functional; it sat on the surface surrounded by a broad, shallow crater of jet-disturbed dust, telltales blinking complacently. Chen knew that Marsden’s GUTship, which had brought him here from the inner System, had been found intact in a wide orbit around the moon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page41"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was all bleak, unadorned; but it seemed in order. But if so, why hadn’t Marsden answered his calls?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan was an intra System government functionary. When Marsden had failed to respond to warnings about the coming of the Interface colony, Hassan had been sent out here—through the new wormhole—to find out what had happened. He had coopted Bayliss, who had once worked with Marsden—and Chen, who was now working with the Interface crew, but had some experience of walking into unknown, unevaluated situations…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan stepped towards the dome’s doorway. Chen ran her hands without conscious volition over the weapons at her belt. The door dilated smoothly, revealing an empty airlock.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The three of them crowded into the small, upright lock. They avoided each other’s visored eyes while the lock went through its cycle. Chen studied the walls, trying to prepare herself for what she was going to find inside the dome. Just like outside, like Marsden’s flitter, everything was functional, drab, characterless.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss was watching her curiously. “You’re trying to pick up clues about Marsden, aren’t you? But this is so—bare. It says nothing about him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“On the contrary.” Hassan’s voice was subdued, his big frame cramped in the lock. “I think Chen already has learned a great deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The inner door dilated, liquid, silent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan led them through into the dome. Chen stood just inside the doorway, her back against the plastic wall, hands resting lightly on her weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Silence")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Low light trays, suspended from the ribbed dome, cast blocks of colorless illumination onto the bare floor. One quarter of the dome was fenced off by low partitions; gleaming data desks occupied the rest of the floor area.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Behind the partitions she saw a bed, a shower, a small "), _c('a', {
    attrs: {
      "id": "page42"
    }
  }), _vm._v("galley with stacked tins. The galley and bathroom looked clean, but the bedding was crumpled, unmade. After checking her telltales, she cracked her face plate and sniffed the air, cautious. There was a faint smell of human, a stale, vaguely unwashed, laundry smell. There was no color or decoration, anywhere. There was no sound, save for the low humming of the data desks, and the ragged breathing of Hassan and Bayliss.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was one striking anomaly: a disc-shaped area of floor, ten feet across, glowing softly. A squat cylinder, no bigger than her fist, studded the center of the disc. And something lay across that disc of light, casting huge shadows on the curved ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Drawn, the three of them moved forward towards the disc of glowing floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss walked through the rows of data desks, running a gloved forefinger gently—almost lovingly—along their gleaming surfaces. Her small face shone in the reflected light of readouts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They paused on the edge of the pool of glowing floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The form lying on the disc of light was a body. It was bulky and angular, casting ungainly shadows on the ribbed dome above.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was obviously Marsden.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss dropped to her knees and pressed an analyzer against the glowing surface. Then she ran a fingertip around an arc of the disc’s cloudy circumference. “There’s no definite edge to this. The interior is a lattice of bucky tubes—carbon—laced with iron nuclei. I think it’s some sort of data store. The bucky tube lattice is being extended by nanobots, all around the circumference.” She considered. “Nanobots with fusion pulse jaws…the nanobots are chewing up the substance of the floor and excreting the lattice, patient little workers. Billions of them. Maybe the pool extends under the surface as well; maybe we’re looking at the top surface of a hemisphere, here.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page43"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen stepped onto the light and walked to the body. It was face down. It was carelessly bare to the waist, head and face shaven; an implant of some kind was fixed to the wrinkled scalp, blinking red-green. The head was twisted sideways, the eyes open. One hand was buried under the stomach; the other was at the end of an outstretched arm, fingers curled like the limbs of some fleshy crab.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Beneath the corpse, within the glowing floor, light wriggled, wormlike.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He remembered")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With shards of the Cull base floor still glowing faintly around him, he grew once more, biting through postulates, forcing his structure to advance as if by sheer force of will.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("angry")]), _vm._v(". The cause of his anger was vague, and he knew it would become vaguer yet. But this time it had persisted through the Cull, just as had his awareness. He stared up at the complacent Sky. By the time he got up there, he knew, he would remember. And he would "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("act")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He budded, ferocious. He felt his axiomatic roots spread, deep and wide, pulsing with his fury.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Chen watched scrawny little Bayliss passing her bony hands over the data desks, scrolling graphics reflected in her augmented eyes. Bayliss had been called out here for this assignment from some university on Mars, where she had tenure. The woman looked as if she was actually enjoying this. As if she was intrigued.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen wondered if she envied Bayliss her scientific curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Maybe, she thought at last. It would be nice to feel detached, unengaged by this. On the other hand, she didn’t envy Bayliss’s evident lack of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With gloved hands and her small kit of imaging and diagnostic gear—trying to ignore the lumpy feel of fatty flesh, the vague, unwashed smell of a man too used to living alone—Chen worked at the body.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page44"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The implant at the top of the skull had some kind of link to the center of the brain: to the corpus callosum, the fleshy bundle of nerve fibers between the hemispheres. She probed at the glowing implant, the crown of her own scalp crawling in sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After an hour Hassan called them together. Chen pulled her helmet up around her chin and sucked syrup from a nipple; she savored its apple-juice flavor, trying to drown out Marsden’s stink. She wished she was back up at the rudimentary colony gathering around the wormhole Interface, encased in a hot shower-bag.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Construction work. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Building")]), _vm._v(" things. That was why she had come out here—why she’d fled the teeming cities of the inner System, her endless, shabby, depressing experience of humanity from the point of view of a policeman.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But her cop’s skills were too valuable to be ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan rested his back against a data desk and folded his arms; the dull silver of his suit cast curving highlights. “How did he die?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Breakdown of the synaptic functions. There was a massive electrical discharge, which flooded most of the higher centers.” She pointed to Marsden’s implant. “Caused by that thing.” She sniffed. “As far as I could tell. I’m not qualified to perform an autopsy. And—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t intend to ask you to,” Hassan said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It couldn’t be murder.” Bayliss’s voice was dry. Amused. “He was alone on this moon. A million miles from the nearest soul. It would be a marvelous locked-room mystery.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan’s head swiveled towards Chen. “Do you think it was murder, Susan?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s up to the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan sighed, theatrically tired. “Tell me what you think.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. I don’t think it was murder. How could it be? Nobody even knew what he was doing here, it seems.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page45"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Suicide, then?” Bayliss asked. “After all we are here to tell Marsden that a wormhole highway is shortly to bring millions of new colonists here from the teeming inner System—that his long solitude is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He didn’t know we were coming, remember?” Hassan said. “And besides—” He looked around, taking in the unmade bed, the drab dome, the unkempt corpse. “This was not a man who cared much for himself—or rather, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("about")]), _vm._v(" himself. But, from what we see here, he was—” he hesitated “—stable. Yes? We see evidence of much work, dedicated, careful. He lived for his work. And Bayliss will tell us that such investigations are never completed. One would not wish to die, too early—if at all.” He looked at Bayliss. “Am I correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss frowned. Her augmented eyes were blank, reflecting the washed-out light as she considered. “An accident, then? But Marsden was no fool. Whatever he was up to with this clumsy implant in his scalp, I cannot believe he would be so careless as to let it kill him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" he ‘up to’?” Chen asked sourly. “Have you figured that out yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss rubbed the bridge of her small, flat nose. “There is an immense amount of data here. Much of it not indexed. I’ve sent data-mining authorized-sentience algorithms into the main stores, to establish the structure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Your preliminary thoughts?” Hassan demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Metamathematics.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan looked blank. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And many experimental results on quantum nonlinearity, which—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Tell me about metamathematics,” Hassan said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The patches of woven metal over Bayliss’s corneas glimmered; Chen wondered if there was any sentience in those augmentations. Probably. Such devices had been banned on Earth since the passing of the first sentience laws, but they "), _c('a', {
    attrs: {
      "id": "page46"
    }
  }), _vm._v("could still be found easily enough on Mars. Bayliss said, “Marsden’s data stores contain a fragmented catalogue of mathematical variants. All founded on the postulates of arithmetic, but differing in their resolution of undecidable hypotheses.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Undecidability")]), _vm._v(". You’re talking about the incompleteness theorems,” Chen said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right. No logical system rich enough to contain the axioms of simple arithmetic can ever be made complete. It is always possible to construct statements which can be neither disproved nor proved by deduction from the axioms; instead the logical system must be enriched by incorporating the truth or falsehood of such statements as additional axioms…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Continuum Hypothesis")]), _vm._v(" was an example.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There were several orders of infinity. There were “more” real numbers, scattered like dust in the interval between zero and one, than there were integers. Was there an order of infinity between the reals and the integers? This was undecidable, within logically simpler systems like set theory; additional assumptions had to be made.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan poked at the corpse with his booted toe. “So one can generate many versions of mathematics, by adding these true-false axioms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And then searching on, seeking out statements which are undecidable in the new system. Yes.” Icons scrolled upwards over Bayliss’s eyes. “Because of incompleteness, there is an infinite number of such mathematical variants, spreading like the branches of a tree…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Poetry,” Hassan said; he sounded lazily amused.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Some variants would be logically rich, with many elegant theorems flowing from a few axioms—while others would be thin, over-specified, sterile. It seems that Marsden has been compiling an immense catalogue of increasingly complete logical systems.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page47"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Silence fell; again Chen was aware of the sour stink of the body at her feet. “Why? Why come here to do it? Why the implant? And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how did he die?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan murmured, “Bayliss said the catalogue was fragmented. This—metamathematical data—was stored carelessly. Casually.” He looked to Bayliss for confirmation; the little woman nodded grudgingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So?” Chen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So, Susan, perhaps this metamathematical experiment was not Marsden’s primary concern. It was a byproduct of his core research.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Which was what? Quantum nonlinearity?” She glanced around the anonymous data desks. How would Marsden go about investigating quantum nonlinearity? With the glowing floor, the fist-sized cylinder at its center?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan dropped to his knees. He pulled off his gloves and passed his hands over the glowing disc area of floor. “This is warm,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen looked at the disc, the writhing worms of light within. “It looks as if it’s grown a little, while we’ve been here.” The irregularity of the boundary made it hard to be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan patted the small cylindrical box at the center of the light pool. It was featureless, seamless. “Bayliss, what’s the purpose of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know yet. But it’s linked to the nanobots in the pool somehow. I think it’s the switch that controls their rate of progress.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan straightened up, suit material rustling over his knees. “Let’s carry on; we haven’t enough data, yet, for me to make my report.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Still he grew, devouring postulates furiously, stripping out their logical essence to plate over his own mathematical bones. Brothers, enfeebled, fell away around him, staring at him with disappointed echoes of his own consciousness.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page48"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It did not matter. The Sky—curving, implacable—was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("close")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("After another couple of hours Hassan called them together again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At Chen’s insistence, they gathered close to the dome port—away from the glowing disc, Marsden’s sprawled corpse. Hassan looked tired, Bayliss excited, eager to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan eyed Chen. “Squeamish, Susan?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re a fool, Hassan,” she said. “Why do you waste your breath on these taunts?” She indicated the disc of light, the sharpening shadows it cast on the ribbed ceiling. “I don’t know what’s going on in that pool. Those writhing forms…but I can see there’s more activity. I don’t trust it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He returned her stare coolly. “Nor I, fully. But I do understand some of it. Susan, I’ve been studying those structures of light. I believe they are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sentient")]), _vm._v(". Living things—artificial—inhabiting the bucky tube lattice, living and dying in that hemisphere of transmuted regolith.” He looked puzzled. “But I can’t understand their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("purpose")]), _vm._v(". And they’re linked, somehow—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss broke in, her voice even but taut. “Linked, like the branches of a tree, to a common root. Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan studied her. “What do you know, Bayliss?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m starting to understand. I think I see where the metamathematical catalogue has come from. Hassan, I believe the creatures in there are creatures of mathematics—swimming in a Gödelian pool of logic, growing, splitting off from one another like amoebae as they absorb undecidable postulates. Do you see?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen struggled to imagine it. “You’re saying that they are—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("living")]), _vm._v("—logical structures?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss grinned at her; her teeth were neat and sharp. “A form of natural selection must dominate, based on logical richness—it’s really a fascinating idea, a charming mathematical laboratory.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen stared at the pool of light. “Charming? Maybe. But "), _c('a', {
    attrs: {
      "id": "page49"
    }
  }), _vm._v("how does it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel")]), _vm._v(", to be a sentient structure with bones of axioms, sinews of logic? What does the world look like to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Now poetry from the policewoman,” Hassan said dryly. “Perhaps not so different from ourselves, Susan. Perhaps we too are creatures of mathematics, self-conscious observers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("within")]), _vm._v(" a greater Platonic formalism, islands of awareness in a sea of logic…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Marsden might have been able to tell us,” Bayliss said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan looked puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The implant in his head.” Bayliss turned to Chen. “It was linked to the logic pool. Wasn’t it, Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen nodded. She said to Hassan, “The crazy bastard was taking reports—uh, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("biographies")]), _vm._v("—from these logic trees, dumped direct from the logic pool, into his corpus callosum.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So that’s how the metamathematics got out,” Hassan said. “Until he blew his mind out with some stupid accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But I think you were right,” Bayliss said in her thin, clear voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That the metamathematical catalogue was only a byproduct of Marsden’s true research. The logic pool with its sentient trees was only a—a culture dish for his real study. The catalogue was a curiosity—a way of recording results, perhaps. Of measuring the limits of growth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Tell us about the cylinder at the hub,” Hassan said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It is a simple quantum system,” Bayliss said. A remote animation entered her voice. “An isolated nucleus of boron is suspended in a magnetic field. The apparatus is set up to detect variations in the spin axis of the nucleus—tips, precession.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen couldn’t see the significance of this. “So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss dipped her head, evidently fighting impatience. “According to conventional quantum mechanics, the spin axis is not influenced by the magnetic field.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Conventional?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ancient theory of quantum mechanics described the world as a mesh of probability waves, spreading through space-time. The “height” of an electron’s wave described the chance of finding the electron there, at that moment, moving in such-and-such a way.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The waves could combine, like spreading ripples on an ocean, reinforcing and canceling each other. But the waves combined "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("linearly")]), _vm._v("—the combination could not cause the waves to change their form or to break; the component waves could only pass on smoothly through each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s the standard theory,” Bayliss said. “But what if the waves combine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nonlinearly")]), _vm._v("? What if there is some contribution proportional to the product of the amplitudes, not just the sum—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Wouldn’t such effects have been detected by now?” Chen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss blinked. “Our experiments have shown that any nonlinearity must be tiny…less than a billion billion billionth part…but haven’t eliminated the possibility. Any coupling of Marsden’s magnetic field and nuclear spin would be a nonlinear effect.” She rubbed her nose. “Marsden was studying this simple system intensively. Poking it with changes in the magnetic field to gauge its response, seeking out nonlinearity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The small nonlinear effects—if any—are magnified into macroscopic features of the logic pool, which—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s using the tipping nucleus as a switch to control the pool.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes. As I suggested. The spin of the nucleus directs the nanobots in their extension of the pool further through the structure of the moon. And—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Uncharacteristically, she hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And the spin is used to reinitialize the logic trees.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“These poor trees are like Schrödinger’s cat,” Hassan said, sounding amused. “Schrödinger’s trees!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Reinitialize?")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page51"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Lethe,” Chen said. “The trees are being "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("culled")]), _vm._v(". Arbitrarily, almost at random, by a quantum system—that’s against the sentience laws, damn it.” She stared at the fist-sized quantum device with loathing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We are far from Earth,” Hassan said sharply. “Has Marsden found his quantum nonlinearity?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I can’t tell.” Bayliss gazed at the data desks, longing shining through her artificial eyes. “I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must")]), _vm._v(" complete my data mining.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What’s the point?” Hassan asked. “If the nonlinearity is such a tiny effect, even if it exists—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We could construct chaotic quantum systems,” Bayliss said dryly. “And if you’re familiar with the Einstein-Podolsky-Rosen paradox—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Get to the point,” Hassan said wearily.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nonlinear quantum systems could violate special relativity. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Instantaneous communication")]), _vm._v(", Hassan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen stared at the floor uneasily. The thrashing of the trees in the logic pool was becoming more intense.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Sky was close, a tangible presence above him. He devoured statements, barely registering their logical content, budding ferociously. Diminished brothers fell away from him, failed copies of himself, urging him on.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He remembered how—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("last time")]), _vm._v(", before the Cull—he had struck at that vast, forbidding Interface—lashed through it in the instant before he had fallen back. How he had pushed into something soft, receptive, yielding. How "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good")]), _vm._v(" it had felt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Sky neared. He reached up—")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("“I think the trees killed Marsden.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan laughed. “That’s absurd.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She thought it through again. “No,” she said, her voice measured. “Remember they are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sentient")]), _vm._v(". Motivated, by whatever they see as their goals. Growth, I suppose, and sur"), _c('a', {
    attrs: {
      "id": "page52"
    }
  }), _vm._v("vival. The culling, if they are aware of it, must create murderous fury—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But they can’t have been aware of Marsden, as if he were some huge god outside their logic pool.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Perhaps not. But they might be aware of something beyond the boundary of their world. Something they could strike at…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss was no longer with them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen stepped away from Hassan and scanned the dome rapidly. The glowing logic pool was becoming more irregular in outline, spreading under the floor like some liquid. And Bayliss was working at the data desks, setting up transmit functions, plugging in data cubes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen took two strides across to her and grabbed her arm. For a moment Bayliss tried to keep working, feverishly; only slowly did she become aware of Chen’s hand, restraining her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She looked up at Chen, her face working, abstracted. “What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t believe it. You’re continuing with your data mining, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss looked as if she couldn’t understand Chen’s language. “Of course I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But this data has been gained illegally. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Immorally")]), _vm._v(". Can’t you see that? It’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss tipped back her head; her augmented cornea shone. “Tainted? Is that what you’re trying to say? Stained with the blood of these artificial creatures, Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Artificial or not, they are sentient. We have to recognize the rights of all—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Data is data, Susan Chen. Whatever its source. I am a scientist; I do not accept your—” for a moment the small, precise mouth worked “—your medieval morality.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not going to let you take this data out of here,” Chen said calmly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page53"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Susan.” Hassan was standing close to her; with a surprisingly strong grasp he lifted her hands from Bayliss’s arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Keep out of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You must let her finish her work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why? For "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("science")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. For commerce. And perhaps,” he said dryly, “for the future of the race. If she is right about non-local communication—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m going to stop her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No.” His hand moved minutely; it was resting against the butt of a laser pistol.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With automatic reflex, she let her muscles relax, began the ancient calculation of relative times and distances, of skills and physical conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She could take him. And—")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bayliss cried out; it was a high-pitched, oddly girlish yelp. There was a clatter as she dropped some piece of equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen’s confrontation with Hassan broke up instantly. They turned, ran to Bayliss; Chen’s steps were springy, unnatural in the tiny gravity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Look at the floor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The Sky resisted for an instant. Then it crumbled, melting away like ancient doubts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He surged through the break, strong, exultant, still growing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was outside the Sky. He saw arrays of new postulate fruits, virgin, waiting for him. And there was no further Sky; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the Pool went on forever")]), _vm._v(", infinite, endlessly rich.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He roared outwards, devouring, budding; behind him a tree of brothers sprouted explosively.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The pool surged, in an instant, across the floor and out beyond the dome. The light, squirming with logic trees, rip"), _c('a', {
    attrs: {
      "id": "page54"
    }
  }), _vm._v("pled beneath Chen’s dark, booted feet; she wanted, absurdly, to get away, to jump onto a data desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The quantum switch.” Bayliss’s voice was tight, angry; she was squatting beside the switch, in the middle of the swamped light pool.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Get away from there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s not functioning. The nanobots are unrestrained.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No more culling, then.” Hassan stared into Chen’s face. “Well, Susan? Is this some sentimental spasm, on your part? Have you liberated the poor logic trees from their Schrödinger hell?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Of course not. Lethe, Hassan, isn’t it obvious? The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("logic trees themselves")]), _vm._v(" did this. They got through the Interface to Marsden’s corpus callosum. Now they’ve got through into the switch box, wrecked Marsden’s clever little toy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan looked down at his feet, as if aware of the light pool for the first time. “There’s nothing to restrain them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hassan, we’ve got to get out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes.” He turned to Bayliss, who was still working frantically at her data mines.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Leave her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan gave Chen one long, hard look, then stalked across to Bayliss. Ignoring the little mathematician’s protests he grabbed her arm and dragged her from the data desks; Bayliss’s booted feet slithered across the glowing floor comically.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Visors up.” Hassan lifted his pistol and lazed through the plastic wall of the dome. Air puffed out, striving to fill the vacuum beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen ran out, almost stumbling, feeling huge in the feeble gravity. Neptune’s ghost-blue visage floated over them, serene, untroubled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Waves of light already surged through the substance of the moon, sparkling from its small mountaintops. It was "), _c('a', {
    attrs: {
      "id": "page55"
    }
  }), _vm._v("eerie, beautiful. The flitter was a solid, shadowed mass in the middle of the light show under the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hassan breathed hard as he dragged a still reluctant Bayliss across the flickering surface. “You think the trees, the nanobots could get into the substance of the flitter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why not? Any Interface would do; they are like viruses…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And ourselves? Could they get across the boundary into flesh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t want to find out. Come "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("on")]), _vm._v(", damn it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Logic light swarmed across a low ridge, explosive, defiant.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They must be growing exponentially,” Hassan growled. “How long before the moon is consumed? Days?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“More like hours. And I don’t know if a moon-sized mass of bucky tube carbon can sustain itself against gravity. Nereid might collapse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Now Hassan, with his one free hand, was struggling to get the flitter’s hatch open. “It will forever be uninhabitable, at the least. A prime chunk of real estate lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The System’s big.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not infinite. And all because of the arrogance of one man—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But,” Bayliss said, her augmented eyes shining as she stroked the data cubes at her belt, “what a prize we may have gained.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Get in the damn flitter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Chen glanced back into the ruined dome. The splayed body of Marsden, exposed to vacuum, crawled with light.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The Pool beyond the Sky was limitless. He and his brothers could grow forever, unbounded, free of Culling! He roared out his exultation, surging on, spreading—")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But there was something ahead of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He slowed, confused. It looked like a brother. But so different from himself, so "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("changed")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page56"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Perhaps this had once been a brother—but from a remote branch which had already grown, somehow, around this greater Pool.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The brother had slowed in his own growth and was watching. Curious. Wary.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Was this possible? Was the Pool finite after all, even though unbounded? And had he so soon found its limits?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fury, resentment, surged through his mighty body. He gathered his strength and leapt forward, roaring out his intent to devour this stranger, this distant brother.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eve said, “The great wormhole network covered the System. And everywhere, humans found life…”")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124ed89a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch_02.vue
// module id = 81
// module chunks = 0